const AUDIO_STATUS = {
  PLAYING: 'PLAYING',           // 播放中
  PAUSE: 'PAUSE',               // 暂停
  BEFORE_INIT: 'BEFORE_INIT',   // 初始化
  INIT: 'INIT',                 // 初始化完成
  END: 'END',                   // 播放结束
  NOT_EXIST: 'NOT_EXIST'        // 源语音不存在
}

const PLAY_MODE = {
  SINGLE: "SINGLE", // // 单曲循环
  ORDER: "ORDER",   // 顺序播放
  RANDOM: "RANDOM"  // 随机播放
}

const isIndexInRange = (state, index) => index > -1 &&  index < state.audioList.length

export const audioPlayer = {
  state () {
    return {
      audioList: [
        // 这里存放audio的src
      ], 
      currentAudio: {
        audio: null,
        status: AUDIO_STATUS.BEFORE_INIT,
        msg: null,
        index: -1, // 存放当前audio在List中的索引
      },
      playMode: PLAY_MODE.ORDER
    }
  },

  mutations: {
    setAudioList (state, audioList) {
      if (Array.isArray(audioList)) {
        if (Array.isArray(state.audioList)) {
          state.audioList = state.audioList.concat(audioList)
        } else {
          state.audioList = audioList
        }
      } else {
        throw new TypeError(`the incoming param audioList:${audioList} is not a array[vuex]`)
      }
    },

    clearAudioList (state) {
      state.audioList = null
    },

    setCurrentAudio (state, currentAudio) {
      if (typeof currentAudio === 'object') {
        state.currentAudio.audio = currentAudio
      } else {
        throw new TypeError('currentAudio is not a object[vuex]')
      }
    },

    // 暂未使用
    // 设置当前Audio并往history中添加一个新的audio 
    // 并将historyAnchor赋值为新audio的history索引
    // 锚点作用是从 历史播放记录中 中间添加， 
    // 即比方说用户点击几次上一首，又点击下一首应该执行的逻辑
    setCurrentAudioAdd (state, currentAudio) {
      // 先直接提交CurrentAudio
      this.commit('setCurrentAudio', currentAudio)

      // 如果锚点小于0， 则赋值为0
      if (state.historyAnchor < 0) {
        state.history[0] = currentAudio
        state.historyAnchor = 0
        state.history.length = 1
      } else if (state.historyAnchor < state.history.length) {
        // 当锚点的值小于 history.length  时才能添加
        state.historyAnchor = state.historyAnchor + 1
        state.history[state.historyAnchor] = currentAudio
        state.history.length = state.historyAnchor + 1
      } else {
        throw new RangeError(`the historyAnchor: ${state.historyAnchor} is higher than history.length${state.history.length} `)
      }
    },

    setAudioMsg (state, audioMsg) {
      if (typeof audioMsg === 'object') {
        state.currentAudio.msg = audioMsg
      } else {
        throw new TypeError('audioMsg is not a object[vuex]')
      }
    },

    setAudioIndex (state, index) {
      if (typeof index === 'number') {
        if (index > -1 && index < state.audioList.length) {
          state.currentAudio.index = index
        } else {
          throw new RangeError(`the index: ${index} is out of range of this audio array[vuex]`)
        }
      } else {
        throw new TypeError(`index: ${index} is not a number[vuex]`)
      }
    },

    play (state) {
      state.currentAudio.status = AUDIO_STATUS.PLAYING
    },

    pause (state) {
      state.currentAudio.status = AUDIO_STATUS.PAUSE
    },

    // 当current.index没有主动传入时调用, 从audioList中查找当前audio的id
    findIndexInAudioList (state, audio) {
      if (typeof audio === 'object') {
        if (Object.prototype.hasOwnProperty.call(audio, 'id')) {
          let index = state.audioList.findIndex(mem => mem.id === audio.id)
          
          // 因为mutation的调用形式 不管是否mapMutation， 最终都是store.commit
          // 所以使用this
          this.commit('setAudioIndex', index)
        } else {
          throw new TypeError(`audio is not have property id[vuex]`)
        }
      } else {
        throw new TypeError(`incoming parameter audio: ${audio} is not a object[vuex]`)
      }
    },

    nextAudio (state, playMode) {
      if (typeof playMode === 'string') {
        let oldIndex = state.currentAudio.index

        if (isIndexInRange(state, oldIndex)) {
          let newIndex = 0

          // 随机播放上一首 太麻烦，目前只启用顺序播放
          // 具体以后添加
          switch(playMode) {
            // 顺序播放
            case PLAY_MODE.ORDER:
              // 如果当前index是最后一首， 那么下一首将是第一首
              if (oldIndex < state.audioList.length - 1) {
                newIndex = oldIndex + 1
                this.commit('setCurrentAudio', state.audioList[newIndex])
              } else {
                this.commit('setCurrentAudio', state.audioList[0])
              }
              break
            // 单曲循环
            case PLAY_MODE.SINGLE: 
              // 同上
              if (oldIndex < state.audioList.length - 1) {
                newIndex = oldIndex + 1
                this.commit('setCurrentAudio', state.audioList[newIndex])
              } else {
                this.commit('setCurrentAudio', state.audioList[0])
              }
              break
            // 随机播放 -- 涉及到历史记录的问题
            case PLAY_MODE.RANDOM:
              // 生成 0 到 audioList.length - 1 索引 的随机数
              newIndex = Math.random() * (state.audioList.length + 1) >> 0
              this.commit('setCurrentAudio', state.audioList[newIndex])
              break
            default: 
              throw new Error(`incoming playMode ${playMode} is not include in defined playModeList`)
          }
          
          this.commit('setAudioIndex', newIndex)
          state.currentAudio.status = AUDIO_STATUS.BEFORE_INIT
        } else {
          throw new RangeError(`the index: ${oldIndex} is not in audioList array range`)
        }
      } else {
        throw new TypeError(`playMode: ${playMode} is not a string `)
      }
    },

    // 目前只有顺序播放
    prevAudio (state) {
      let oldIndex = state.currentAudio.index
      let newIndex = 0

      // 如果当前index是第一首， 那么上一首将是最后一首
      if (oldIndex === 0) {
        newIndex = state.audioList.length - 1
      } else {
        newIndex = oldIndex - 1
      }

      this.commit('setCurrentAudio', state.audioList[newIndex])
      this.commit('setAudioIndex', newIndex)
    }
  },

  getters: {
    audioList: state => state.audioList,
    currentAudio: state => state.currentAudio,
    isPlay: state => state.currentAudio.status === AUDIO_STATUS.PLAYING,
    isIndexInRange: state => isIndexInRange(state, state.currentAudio.index),
    PLAY_MODE: () => PLAY_MODE
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/audio-player/index.js